<template>
  <div class="inventory-manage">
    <section class="banner-wrapper">
      <div class="content">
        <div class="download-btns">
          <button class="download-inventory-btn">
            <a class="full-link"
               href="/PMBOX/up/sg-master.exe"
               download="商购-库存管理软件.exe"
               target="_blank"></a>
          </button>
          <button class="download-billing-btn">
            <a class="full-link"
               href="/PMBOX/up/sg-shipment.exe"
               download="商购-出单管理软件.exe"
               target="_blank"></a>
          </button>
          <button class="download-pdj-btn">
            <a class="full-link"
               href="/PMBOX/up/sg-kcpd.apk"
               download="sg-kcpd.apk"
               target="_blank"></a>
          </button>
        </div>
      </div>
      <div class="banner-left-bg" style="background: #192794;"></div>
      <div class="banner-right-bg" style="background: #192794;"></div>
    </section>

    <div class="scene-wrapper">
      <div class="scene scene-1"></div>
      <div class="scene scene-2"></div>
      <div class="scene scene-3"></div>
      <div class="scene scene-4"></div>
    </div>

    <div class="footer-download-wrapper">
      <h3 class="title">立即下载</h3>

      <div class="downloads">
        <button class="download-inventory">
          <a class="full-link"
             href="/PMBOX/up/sg-master.exe"
             download="商购-库存管理软件.exe"
             target="_blank"></a>
        </button>
        <button class="download-billing">
          <a class="full-link"
             href="/PMBOX/up/sg-shipment.exe"
             download="商购-出单管理软件.exe"
             target="_blank"></a>
        </button>
        <button class="download-pdj">
          <a class="full-link"
             href="/PMBOX/up/sg-kcpd.apk"
             download="sg-kcpd.apk"
             target="_blank"></a>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import preloadImage from 'src/modules/preload-image';

export default {
  created() {
    setTimeout(() => {
      preloadImage(require('./images/download-billing-hover.png'));
      preloadImage(require('./images/download-billing-active.png'));
      preloadImage(require('./images/download-inventory-hover.png'));
      preloadImage(require('./images/download-inventory-active.png'));
      preloadImage(require('./images/download-pdj-hover.png'));
      preloadImage(require('./images/download-pdj-active.png'));
      preloadImage(require('./images/download-billing-big-hover.png'));
      preloadImage(require('./images/download-billing-big-active.png'));
      preloadImage(require('./images/download-inventory-big-hover.png'));
      preloadImage(require('./images/download-inventory-big-active.png'));
      preloadImage(require('./images/download-pdj-big-hover.png'));
      preloadImage(require('./images/download-pdj-big-active.png'));
    }, 100);
  },
};
</script>

<style lang="scss" scoped>
  .inventory-manage {
    .banner-wrapper {
      position: relative;
      height: 540px;
      background: url("images/banner.png") center no-repeat;

      .banner-left-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 50%;
        height: 100%;
        z-index: -1;
      }

      .banner-right-bg {
        position: absolute;
        top: 0;
        right: 0;
        width: 50%;
        height: 100%;
        z-index: -1;
      }

      .content {
        width: $content-width;
        margin: 0 auto;
      }

      .download-btns {
        position: absolute;
        bottom: 120px;
        margin-left: 614px;

        .download-inventory-btn {
          @include plain-button;
          width: 201px;
          height: 48px;
          background: url("images/download-inventory.png") center no-repeat;
          background-size: 100% 100%;

          &:hover {
            background-image: url("images/download-inventory-hover.png");
          }

          &:active {
            background-image: url("images/download-inventory-active.png");
          }
        }

        .download-billing-btn {
          @include plain-button;
          width: 165px;
          height: 48px;
          margin-left: 16px;
          background: url("images/download-billing.png") center no-repeat;
          background-size: 100% 100%;

          &:hover {
            background-image: url("images/download-billing-hover.png");
          }

          &:active {
            background-image: url("images/download-billing-active.png");
          }
        }

        .download-pdj-btn {
          @include plain-button;
          width: 136px;
          height: 48px;
          margin-left: 16px;
          background: url("images/download-pdj.png") center no-repeat;
          background-size: 100% 100%;

          &:hover {
            background-image: url("images/download-pdj-hover.png");
          }

          &:active {
            background-image: url("images/download-pdj-active.png");
          }
        }
      }
    }

    .title {
      margin: 0;
      text-align: center;
      color: #2a2a2a;
      font-size: 36px;
      font-weight: lighter;
      letter-spacing: 4px;
    }

    .scene-wrapper {
      width: 886px;
      margin: 0 auto;
      padding-top: 56px;

      .scene {
        width: 886px;
        height: 360px;
        background-repeat: no-repeat;
        background-position: center top;
        background-color: transparent;
      }

      .scene-1 {
        background-image: url("images/scene-1.png");
      }

      .scene-2 {
        background-image: url("images/scene-2.png");
      }

      .scene-3 {
        background-image: url("images/scene-3.png");
      }

      .scene-4 {
        background-image: url("images/scene-4.png");
      }
    }

    .footer-download-wrapper {
      margin-top: 90px;
      padding-top: 68px;
      padding-bottom: 156px;
      background: #192a97;
      text-align: center;

      .title {
        color: #ffffff;
      }

      .downloads {
        margin-top: 70px;
      }

      .download-inventory {
        @include plain-button;
        width: 380px;
        height: 80px;
        background: url("images/download-inventory-big.png") center no-repeat;
        background-size: 100% 100%;

        &:hover {
          background-image: url("images/download-inventory-big-hover.png");
        }

        &:active {
          background-image: url("images/download-inventory-big-active.png");
        }
      }

      .download-billing {
        @include plain-button;
        width: 328px;
        height: 80px;
        margin-left: 34px;
        background: url("images/download-billing-big.png") center no-repeat;
        background-size: 100% 100%;

        &:hover {
          background-image: url("images/download-billing-big-hover.png");
        }

        &:active {
          background-image: url("images/download-billing-big-active.png");
        }
      }

      .download-pdj {
        @include plain-button;
        width: 258px;
        height: 80px;
        margin-left: 34px;
        background: url("images/download-pdj-big.png") center no-repeat;
        background-size: 100% 100%;

        &:hover {
          background-image: url("images/download-pdj-big-hover.png");
        }

        &:active {
          background-image: url("images/download-pdj-big-active.png");
        }
      }
    }
  }
</style>
